import React from "react"

export default function Close() {
   return (
      <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
         <g clipPath="url(#clip0_3_11791)">
            <path d="M19.1426 6.80648L17.7326 5.39648L12.1426 10.9865L6.55258 5.39648L5.14258 6.80648L10.7326 12.3965L5.14258 17.9865L6.55258 19.3965L12.1426 13.8065L17.7326 19.3965L19.1426 17.9865L13.5526 12.3965L19.1426 6.80648Z" fill="#B8BAC2" />
         </g>
         <defs>
            <clipPath id="clip0_3_11791">
               <rect width="24" height="24" fill="white" transform="translate(0.142578 0.396484)" />
            </clipPath>
         </defs>
      </svg>
   )
}
